import {
  Bookmark,
  BookUser,
  Building,
  Building2,
  ClipboardCheck,
  ClipboardList,
  FileSearch,
  FileUser,
  Inbox,
  LayoutDashboard,
  TrendingUp,
  UserLock,
  Users,
  UserSearch,
} from 'lucide-react';

import { User } from '@itp/talent';
import { getRoutingPath, ROUTES } from '@itp/talent/constants/routingPath';

import { MenuItem } from './asideNavigation';
const SHOW_ACCOUNTING = false;
const SHOW_ENTERPRISE = false;

export const companyMenuItems = (user: User): MenuItem[] => {
  const { companies, permissions, selectedCompanyId } = user;

  const showDashboard =
    permissions?.companyTalentRoster?.read ||
    permissions?.jobDescription?.read ||
    permissions?.jobAssignment?.read;

  const showJobs =
    permissions?.jobDescription?.read ||
    permissions?.jobAd?.read ||
    permissions?.talentJobApplication?.read ||
    permissions?.talentJobApplication?.read;

  const showTalents =
    SHOW_ENTERPRISE &&
    (permissions?.jobDescription?.read ||
      permissions?.jobAssignment?.read ||
      permissions?.companyTalentRoster?.read);

  const showCompanyManagement =
    (permissions?.company?.read && permissions?.company?.update) ||
    permissions?.companyOnUser?.read ||
    permissions?.companyRole?.read;

  return [
    ...(showDashboard
      ? [
          {
            isMainMenu: true,
            label: 'dashboard',
          },
        ]
      : []),
    ...(showDashboard
      ? [
          {
            icon: LayoutDashboard,
            iconSelected: LayoutDashboard,
            label: 'Dashboard',
            link: getRoutingPath(ROUTES.COMPANY_DASHBOARD),
          },
        ]
      : []),

    ...(showTalents
      ? [
          {
            isMainMenu: true,
            label: 'Talent Management',
          },
        ]
      : []),

    ...(SHOW_ENTERPRISE && permissions?.jobDescription?.read
      ? [
          {
            icon: ClipboardList,
            iconSelected: ClipboardList,
            label: 'Job Descriptions',
            link: getRoutingPath(ROUTES.COMPANY_JOB_DESCRIPTIONS),
          },
        ]
      : []),
    ...(SHOW_ENTERPRISE && permissions?.jobAssignment?.read
      ? [
          {
            icon: FileUser,
            iconSelected: FileUser,
            label: 'Talent Assignments',
            link: getRoutingPath(ROUTES.COMPANY_TALENT_ASSIGNMENTS),
          },
        ]
      : []),
    ...(SHOW_ENTERPRISE && permissions?.companyTalentRoster?.read
      ? [
          {
            icon: BookUser,
            iconSelected: BookUser,
            label: 'Talent Roster',
            link: getRoutingPath(ROUTES.COMPANY_TALENT_ROSTER),
          },
        ]
      : []),

    ...(showJobs
      ? [
          {
            isMainMenu: true,
            label: 'Recruiting',
          },
        ]
      : []),

    ...(permissions?.talentProfile?.read
      ? [
          {
            icon: UserSearch,
            iconSelected: UserSearch,
            label: 'Talent search',
            link: getRoutingPath(ROUTES.TALENT_SEARCH),
          },
        ]
      : []),
    ...(permissions?.jobAd?.read
      ? [
          {
            icon: FileSearch,
            iconSelected: FileSearch,
            label: 'Job Ads',
            link: getRoutingPath(ROUTES.COMPANY_JOB_ADS),
          },
        ]
      : []),

    ...(permissions?.talentJobApplication?.read
      ? [
          {
            icon: Inbox,
            iconSelected: Inbox,
            label: 'Applications',
            link: getRoutingPath(ROUTES.COMPANY_RECEIVED_JOB_APPLICATIONS),
          },
        ]
      : []),
    ...(permissions?.talentInvitation?.read
      ? [
          {
            icon: ClipboardCheck,
            iconSelected: ClipboardCheck,
            label: 'Invitations',
            link: getRoutingPath(ROUTES.COMPANY_SENT_INVITATIONS),
          },
        ]
      : []),

    ...getAcccounting(permissions),

    ...(showCompanyManagement
      ? [
          {
            isMainMenu: true,
            label: 'Company Management',
          },
        ]
      : []),
    ...(permissions?.company?.read && permissions?.company?.update
      ? [
          {
            icon: Building2,
            iconSelected: Building2,
            label: 'Edit Profile',
            link: `${getRoutingPath(ROUTES.COMPANY_PROFILE)}/${selectedCompanyId}`,
          },
        ]
      : []),
    ...(permissions?.companyOnUser?.read
      ? [
          {
            icon: Users,
            iconSelected: Users,
            label: 'Members',
            link: getRoutingPath(ROUTES.COMPANY_MEMBERS),
          },
        ]
      : []),
    ...(permissions?.companyRole?.read
      ? [
          {
            icon: UserLock,
            iconSelected: UserLock,
            label: 'Roles',
            link: getRoutingPath(ROUTES.COMPANY_ROLES),
          },
        ]
      : []),
    ...(companies.length > 1
      ? [
          {
            icon: Building,
            iconSelected: Building,
            label: 'My companies',
            link: getRoutingPath(ROUTES.COMPANY_MY_COMPANIES),
          },
        ]
      : []),
  ];
};

const getAcccounting = (permissions) => {
  return SHOW_ACCOUNTING
    ? [
        ...(permissions
          ? [
              {
                icon: TrendingUp,
                iconSelected: TrendingUp,
                label: 'Sales',
                link: getRoutingPath(ROUTES.COMPANY_SALES),
              },
            ]
          : []),
      ]
    : [];
};
